module.exports = [{
      plugin: require('../../../node_modules/gatsby-plugin-react-i18next/gatsby-browser.js'),
      options: {"plugins":[],"localeJsonSourceName":"locales","languages":["en-US","tr"],"defaultLanguage":"en-US","siteUrl":"https://lovelica.com","generateDefaultLanguagePage":false,"trailingSlash":"always","i18nextOptions":{"keySeparator":".","nsSeparator":false,"fallbackLng":"en-US","supportedLngs":["en-US","tr"],"defaultNS":"common","interpolation":{"escapeValue":false},"returnNull":false,"returnEmptyString":false}},
    },{
      plugin: require('../../../node_modules/@chakra-ui/gatsby-plugin/gatsby-browser.js'),
      options: {"plugins":[],"resetCSS":true},
    },{
      plugin: require('../../../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"src/images/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"45426b3e7df6d4253c9373f7a7f7e8ab"},
    },{
      plugin: require('../../../node_modules/gatsby-plugin-google-tagmanager/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-5NJ88LXL","includeInDevelopment":true,"routeChangeEventName":"route_change","enableWebVitalsTracking":true,"selfHostedOrigin":"https://stp.lovelica.com","defaultDataLayer":null,"selfHostedPath":"gtm.js"},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
